<template>
  <div class="about">
    <div style="margin-top: 100px;text-align: center;">
      <img src="@/assets/images/maintenance.png" width="200" height="200" />
      <h1><p>Panel zamówień automatycznych już niebawem...</p></h1>

      <div></div>
    </div>
  </div>
</template>

<script>

import {useOrdersManagerModule} from "@/state/pinia/ordersManagerModule";
import {useCommonAppModule} from "@/state/pinia";

export default {
  name: "OrdersManagerOrders",
  computed: {
    ordersModule(){
      return useOrdersManagerModule();
    },
    commonModule(){
      return useCommonAppModule();
    },
    lazyloaderModule(){
      return useLazyLoaderModule();
    },
  },
  methods: {

  },
  watch: {
  },
  created() {
    this.commonModule.httpGetLicensedFeatures();
    this.commonModule.httpGetWorkingProfile();
  },
};
</script>

<style scoped></style>
